import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExportCsvService {
  constructor() { }

  /**
   * Converts array data to CSV format and triggers download
   * @param data Array of objects to convert
   * @param filename Name of the file to download (without extension)
   * @param options Optional configuration for CSV generation
   */
  public exportToCsv(
    data: any[],
    filename: string,
    options: {
      headers?: string[];
      delimiter?: string;
      includeHeaders?: boolean;
    } = {}
  ): void {
    if (!data || !data.length) {
      console.warn('No data to export');
      return;
    }

    const {
      headers = Object.keys(data[0]),
      delimiter = ',',
      includeHeaders = true
    } = options;

    // Create CSV content
    let csvContent = '';

    // Add headers if requested
    if (includeHeaders) {
      csvContent += headers.join(delimiter) + '\n';
    }

    // Add data rows
    data.forEach(item => {
      const row = headers.map(header => {
        const cell = item[header]?.toString() ?? '';
        // Escape quotes and wrap in quotes if contains delimiter or newline
        return cell.includes(delimiter) || cell.includes('\n') || cell.includes('"')
          ? `"${cell.replace(/"/g, '""')}"`
          : cell;
      });
      csvContent += row.join(delimiter) + '\n';
    });

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  /**
   * Helper method to auto-generate column headers from data
   * @param data Sample data to extract headers from
   * @returns Array of unique headers
   */
  public getHeaders(data: any[]): string[] {
    if (!data || !data.length) return [];
    
    const headers = new Set<string>();
    data.forEach(item => {
      Object.keys(item).forEach(key => headers.add(key));
    });
    
    return Array.from(headers);
  }
}